import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import {diamondImgUrl, diamondTitle, diamondPrice} from '../../../../../utils/formatting';
import {cloneArray} from '../../../../../utils/data';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);



class CompareProducts extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {

    super(props);
    this.state = {

    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  selectSetting(product) {
    this.props.productSelectSetting(product);
  }

  isSettingSelected() {
    return this.props.product.selectedSetting !== null;
  }

  selectDiamond(diamond) {
    this.props.productSelectDiamond(diamond);
  }

  isDiamondSelected() {
    return this.props.product.selectedDiamond !== null;
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  renderFavorites() {
    let faveItems = [null, null ,null, null];
    const settingView = this.props.productType == 'setting';
    let noItems = false;

    if(settingView) {
      const selectedLength = this.props.product.compareSettings.length;
      if(selectedLength === 0) {
        noItems = true;
      }
      for(let i = 0; i < faveItems.length; i++) {
        if(i < selectedLength) {
          faveItems[i] = this.props.product.compareSettings[i];
        }
      }
    } else {
      const selectedLength = this.props.product.compareDiamonds.length;
      if(selectedLength === 0) {
        noItems = true;
      }
      for(let j = 0; j < faveItems.length; j++) {
        if(j < selectedLength) {
          faveItems[j] = this.props.product.compareDiamonds[j];
        }
      }
    }

    return <div className='favesWrapper'>

      {noItems ? 
        <div className='noItemsMessage'>Select products to compare</div> :
        null
      }

      {faveItems.map((item, k) => {

        if(item === null) {
          return this.renderNullFave(k);
        }

        if(settingView) {
          return this.renderSettingFave(item, k);
        } else {
          return this.renderDiamondFave(item, k);
        }
      })}
    </div>;
  }

  getNullMessage() {
    switch(this.props.productType) {
      case 'diamond':
        return 'Compare your favorite diamonds here!';
      case 'setting':
        return 'Compare your favorite settings here!';
      default:
        return 'Compare your favorite jewelry here!';
    }
  }

  renderNullFave(idx) {
    return <div className={'faveItem faveEmpty'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='heartSection'>
        <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' />
        <div>{this.getNullMessage()}</div>
      </div>
    </div>;
  }

  renderSettingFave(product, idx) {
    return <div className={'faveItem faveProduct'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='faveRemove' onClick={() => this.removeFavoriteProduct(product)}>&times;</div>
      <div className='faveProductInner'>
        <div className='faveImg' onClick={() => this.internalNav('setting/' + product.sku)}>
          <img src={this.getProductMainImage(product)} />
        </div>
        <div className='faveTitle'>
          <div>{product.name.replace(/Ã©/g, 'é')}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Total Carat Wt:</div>
          <div className={'faveDataValue EllipsisElement'}>{product.ttw_dia} Ct.</div>
        </div>
        <div className='favePrice'>${product.price.toLocaleString()}</div>
        {this.props.product.selectedSetting && product.sku === this.props.product.selectedSetting.sku ?
          <div className={'faveAdd selected'}>Selected</div> :
          <div className='faveAdd' onClick={() => this.selectSetting(product)}>Add to Ring</div>
        }
      </div>
    </div>;
  }

  renderDiamondFave(diamond, idx) {
    return <div className={'faveItem faveDiamond'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='faveRemove' onClick={() => this.removeFavoriteDiamond(diamond)}>&times;</div>
      <div className='faveProductInner'>
        <div className='faveImg' onClick={() => this.internalNav('diamond/' + diamond.id)}>
          <img src={diamond.image} />
        </div>
        <div className='faveTitle'>
          <div>{diamondTitle(diamond)}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Shape:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.shape}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Carat Weight:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.caratWeight}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Color:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.color}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Clarity:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.clarity}</div>
        </div>
        <div className='faveDataRow'>
          {diamond.shape.toLowerCase() == 'round' ?
            <span>
              <div className='faveDataLabel'>Cut:</div>
              <div className={'faveDataValue EllipsisElement'}>{diamond.cut ? diamond.cut : ''}</div>
            </span> :
            <span>
              <div className='faveDataLabel'>&nbsp;</div>
              <div className={'faveDataValue EllipsisElement'}>&nbsp;</div>
            </span>
          }
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>Polish:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.polish}</div>
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>Symmetry:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.symmetry}</div>
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>Fluorescence:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.fluorescence}</div>
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>Measurements:</div>
          <div className={'faveDataValue EllipsisElement'}>{diamond.measurement}</div>
        </div>
        <div className='favePrice'>${diamond.price.toLocaleString()}</div>
        
        {this.props.product.selectedDiamond && diamond.id === this.props.product.selectedDiamond.id ?
          <div className={'faveAdd selected'}>Selected</div> :
          <div className='faveAdd' onClick={() => this.selectDiamond(diamond)}>Add to Ring</div>
        }
      </div>
    </div>;
  }

  removeFavoriteProduct(product) {
    
    let currentIndex = null;
    let faves = cloneArray(this.props.product.compareSettings);

    if(this.props.product.compareSettings.length === 1) {
      this.props.productCompareSetting([]);
      return;
    }

    for(let i = 0; i < faves.length; i++) {
      if(faves[i].sku == product.sku) {
        currentIndex = i;
        break;
      }
    }

    faves.splice(currentIndex, 1);
    this.props.productCompareSetting(faves);
  }

  removeFavoriteDiamond(diamond) {
    
    let currentIndex = null;
    let faves = cloneArray(this.props.product.compareDiamonds);

    if(this.props.product.compareDiamonds.length === 1) {
      this.props.productCompareDiamond([]);
      return;
    }

    for(let i = 0; i < faves.length; i++) {
      if(faves[i].id == diamond.id) {
        currentIndex = i;
        break;
      }
    }

    faves.splice(currentIndex, 1);
    this.props.productCompareDiamond(faves);
  }

  render() {

    const RESULT_LIMIT = 24;
    let pCount = 0;

    return <div className='CompareProducts'>
      {this.renderFavorites()}
    </div>;
  }
}
export default CompareProducts;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const CompareProductsContainer = connect(
  mapStateToProps,
  allActionCreators
)(CompareProducts);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/blocks/CompareProducts.jsx